import { removeChannelMember } from 'flow/actions/channels-actions';
import Loading from 'flow/components/ui-components/Loading';
import Page from 'flow/components/Setting/Page';
import SettingRow from 'flow/components/Setting/SettingRow';
import ContactAvatar from 'flow/components/ui-components/ContactAvatar';
import Icon from 'flow/components/ui-components/Icon';
import IconButton from 'flow/components/ui-components/IconButton';
import useAppContext from 'flow/hooks/useAppContext';
import { ChannelMemberDTO } from 'flow/types/Channel';
import { PbxParams } from 'flow/types/Params';
import { routes } from 'flow/types/routes';

import { TypedMap } from 'flow/types/TypedMap';
import { selectOwnExtensionKey } from 'flow/selectors/ExtensionSelectors';
import { extractName } from 'flow/utils';
import { contactNameSorter } from 'flow/utils/sorter-utils';
import { twMerge } from 'tailwind-merge';
import React from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { generatePath, useHistory, useParams } from 'react-router-dom';

const PbxLiveChatRemoveMember = () => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { channelKey } = useParams<PbxParams>();

    const ownExtensionKey = useAppSelector(selectOwnExtensionKey);
    const channelMembers = useAppSelector((state) =>
        state.channels.getIn(['channels', channelKey, 'channelMemberDTOs']),
    );
    const extensions = useAppSelector((state) =>
        state.extensions.get('extensions'),
    );

    if (!channelMembers) {
        return <Loading />;
    }

    const getContact = (channelMember: TypedMap<ChannelMemberDTO>) =>
        channelMember.get('contactDTO') ||
        extensions
            .find(
                (extension) =>
                    extension.get('chatUserKey') ===
                    channelMember.get('chatUserKey'),
            )
            ?.get('contact');

    return (
        <Page
            header={i18next.t('pbx.edit_members')}
            onClickBack={() =>
                history.push(
                    generatePath(routes['pbx.channels.channelKey.members'], {
                        channelKey,
                    }),
                )
            }
        >
            <ul>
                {channelMembers
                    .sortBy(getContact, contactNameSorter)
                    .map((channelMember) => {
                        const contact = getContact(channelMember);
                        const name =
                            channelMember.get('extensionKey') ===
                            ownExtensionKey
                                ? i18next.t('chat.you')
                                : extractName(contact);

                        return (
                            <li
                                key={channelMember.get('key')}
                                value={channelMember.get('key')}
                                className="relative z-30 list-none"
                            >
                                <SettingRow
                                    className="h-12"
                                    cta={
                                        <div className="flex items-center gap-3">
                                            <IconButton
                                                aria-label={i18next.t(
                                                    'Delete.Button.Text',
                                                )}
                                                onClick={() =>
                                                    dispatch(
                                                        removeChannelMember(
                                                            channelKey,
                                                            channelMember.get(
                                                                'key',
                                                            ),
                                                        ),
                                                    )
                                                }
                                            >
                                                <Icon iconKey="delete" />
                                            </IconButton>
                                        </div>
                                    }
                                >
                                    <ContactAvatar
                                        contact={contact}
                                        fallBackBackgroundColorClass={twMerge(
                                            'group-hover:bg-gray-300 bg-gray-200',
                                        )}
                                        size="small"
                                    />

                                    <div className="truncate text-gray-800">
                                        {name}
                                    </div>
                                </SettingRow>
                            </li>
                        );
                    })}
            </ul>
        </Page>
    );
};

export default PbxLiveChatRemoveMember;
